// extracted by mini-css-extract-plugin
export var shake = "_1r-0";